import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import img1 from '../../media/gallery/1.jpg';
import img2 from '../../media/gallery/2.jpg';
import img3 from '../../media/gallery/3.jpg';
import img4 from '../../media/gallery/4.jpg';
import img5 from '../../media/gallery/5.jpg';
import img6 from '../../media/gallery/6.jpg';
import img7 from '../../media/gallery/7.jpg';
import img8 from '../../media/gallery/8.jpg';
import img9 from '../../media/gallery/9.jpg';
import img10 from '../../media/gallery/10.jpg';
import img11 from '../../media/gallery/11.jpg';
import img12 from '../../media/gallery/12.jpg';
import img13 from '../../media/gallery/13.jpg';
import img14 from '../../media/gallery/14.jpg';
import img15 from '../../media/gallery/15.jpg';
import img16 from '../../media/gallery/16.jpg';
import img17 from '../../media/gallery/17.jpg';
import img18 from '../../media/gallery/18.jpg';
import img19 from '../../media/gallery/19.jpg';
import img20 from '../../media/gallery/20.jpg';
import img21 from '../../media/gallery/21.jpg';
import img22 from '../../media/gallery/22.jpg';
import img23 from '../../media/gallery/23.jpg';
import img24 from '../../media/gallery/24.jpg';
import img25 from '../../media/gallery/25.jpg';
import img26 from '../../media/gallery/26.jpg';
import img27 from '../../media/gallery/27.jpg';

const images: string[] = [
  img1, img2, img3, img4, img5, img6, img7, img8, img9, img10,
  img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,
  img21, img22, img23, img24, img25, img26, img27,
];

const IMAGES_TO_LOAD = 6;
const IMAGES_STEP = 6; // Cuantas imágenes cargar cada vez que se presiona el botón

const LoginImagesCarrusel = () => {
  const [visibleImageCount, setVisibleImageCount] = useState(IMAGES_TO_LOAD);

  const handleLoadMore = () => {
    setVisibleImageCount(prevCount => Math.min(prevCount + IMAGES_STEP, images.length));
  };

  const imagesToShow = images.slice(0, visibleImageCount);
  const hasMoreImages = visibleImageCount < images.length;


  return (
    <section className="py-20 bg-gray-100">

      {/* Sección del Título */}
      <div className="container mx-auto py-10 px-4 sm:px-6">
        <div className="flex flex-wrap items-center -mx-4">
          <div className="w-full md:w-1/2 px-4">
            <h3 className="text-3xl md:text-4xl font-bold mb-4" >Imágenes tomadas:</h3>
          </div>
        </div>
      </div>

      {/* 1. GALERÍA PARA MOBILE (Una columna, carga progresiva. Visible por defecto, oculta en md) */}
      <div className="container mx-auto py-10 md:hidden">
        {/* Cambiamos a grid-cols-1 para el formato wide de una imagen por fila */}
        <div className="grid grid-cols-1 gap-4 px-4">
          {imagesToShow.map((image, index) => (
            <div key={index} className="rounded-lg overflow-hidden shadow-lg bg-white aspect-video"> {/* Usamos aspect-video para un formato más cinematográfico */}
              <img
                src={image}
                alt={`Imagen ${index + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>

        {/* Botón para Cargar Más */}
        {hasMoreImages && (
            <div className="text-center mt-8">
                <button
                    onClick={handleLoadMore}
                    className="bg-blue-500 text-white font-bold py-2 px-6 rounded-full hover:bg-blue-600 transition duration-300 shadow-md"
                >
                    Cargar más imágenes ({visibleImageCount} de {images.length})
                </button>
            </div>
        )}
      </div>

      {/* 2. CARRUSEL PARA WEB (Oculto en mobile, visible en md) */}
      <div className="hidden md:block container mx-auto py-10">
        <Swiper
          modules={[Autoplay, EffectCoverflow]}
          effect="coverflow"
          grabCursor={true}
          centeredSlides={true}
          slidesPerView="auto"
          breakpoints={{
            1024: {
              slidesPerView: 'auto',
            },
          }}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 200,
            modifier: 2,
            slideShadows: false,
          }}
          loop={true}
          autoplay={{
            delay: 2000,
            disableOnInteraction: false,
          }}
          className="mySwiper"
        >
          {images.map((image, index) => (
            <SwiperSlide key={index} className="!w-[280px] sm:!w-[360px] md:!w-[500px]">
              <div className="rounded-xl overflow-hidden shadow-lg bg-white">
                <img
                  src={image}
                  alt={`Marca ${index + 1}`}
                  className="w-full h-full object-contain"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default LoginImagesCarrusel;
